<template>
    <aside class="favorites">
        <section class="favorites__recent-edits">
            <h3>Recently Edited Pages</h3>

            <div v-if="recents.length === 0">
                You have no recently edited pages.
            </div>

            <ul v-else>
                <li v-for="(recent, index) in recents" :key="index">
                    <a :href="`/editor/${ recent.id }`">
                        {{ recent.name }}
                    </a>
                </li>
            </ul>
        </section>

        <section class="favorites__favorites">
            <h3>Favorites</h3>

            <div v-if="favorites.length === 0">
                You currently have no favorited pages.
            </div>

            <ul v-else>
                <li v-for="(favorite, index) in favorites" :key="index" class="favorites__item">
                    <i class="favorites__favorites-icon">
                        <font-awesome-icon :icon="['fas', 'heart']" />
                    </i>

                    <a :href="`/editor/${ favorite.id }`">
                        {{ favorite.name }}
                    </a>

                    <font-awesome-icon class="delete-hover" :icon="['fal', 'times-circle']" @click.stop="removeFavorite(favorite)" />
                </li>
            </ul>
        </section>
    </aside>
</template>

<script>
import { mapMutations, mapState } from 'vuex';

import { REMOVE_FAVORITE } from '@/store/types/mutation-types';

export default {
    name: 'favorites',

    data() {
        return {
            favoritesDummyList: [
                { name: 'Integrations' },
                { name: 'Lifesize vs Others' },
                { name: 'Awards' },
            ],

            recentlyEditedDummyPages: [
                { name: 'Software' },
                { name: 'Meeting Room Devices' },
                { name: 'Lifesize' },
                { name: 'Integrations' },
            ],
        };
    },

    computed: {
        ...mapState({
            favorites: state => state.page.favorites,
            recents: state => state.page.recents,
        }),
    },

    methods: {
        ...mapMutations({
            removeFavorite: REMOVE_FAVORITE,
        }),

        selected() {
            this.$emit('selected');
        },
    },
};
</script>

<style lang="scss">
.favorites {
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;

    ul {
        padding-left: 0;
    }

    li {
        list-style: none;
        margin-top: 8px;
    }

    // prevents the client font color from being inherited:
    a {
        color: var(--app-linkColor);

        &:hover {
            color: var(--app-linkHoverColor);
        }
    }

    &__logo {
        padding: 0 60px;
        padding-top: 30px;
        width: 100px;
    }

    // elements:
    &__recent-edits,
    &__favorites {
        padding: 30px 60px;

        h3 {
            font-size: 24px;
            margin-bottom: 10px;
        }
    }

    &__favorites-icon {
        margin-right: 8px;
        color: $attention-color;
    }

    &__item .delete-hover {
        visibility: hidden;
    }

    &__item:hover .delete-hover {
        visibility: visible;
    }

    .delete-hover {
        margin-left: 8px;
        cursor: pointer;
    }
}
</style>
